import { Navigate, useParams } from 'react-router-dom';
import { useAuth } from '../context/authContext';

const ProtectedRoute = ({ children, allowedRoles }) => {
  const { userData, isAuthenticated } = useAuth();
  const { organizationId } = useParams();

  if (!isAuthenticated()) {
    console.log('No authentication, redirecting to login');
    return <Navigate to="/login" replace />;
  }

  // Additional check for ADMIN users - verify they can only access their own organization
  if (userData?.role === 'ADMIN' && organizationId && organizationId !== userData.organizationId) {
    return <Navigate to={`/organization/${userData.organizationId}`} />;
  }

  return children;
};

export default ProtectedRoute;